import { useMediaQuery, useTheme } from "@mui/material";
import {
  NewsWrapper,
  NewsDesktopView,
  NewsMobileView,
  Container,
  Page,
} from "@/components";

export function NewsFeed() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Page>
      <Container>
        <NewsWrapper>
          {isMobile ? <NewsMobileView /> : <NewsDesktopView />}
        </NewsWrapper>
      </Container>
    </Page>
  );
}
